
import { Component } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { ApiService } from '../../services/api.service';
import { Product } from '../../models/product.model';
import { Vendor } from '../../models/vendor.model';
import { MatDialog } from '@angular/material';
import { CreateEditVendorModalComponent } from './create-edit-vendor-modal/create-edit-vendor-modal.component';
import { DialogType, AlertService } from '../../services/alert.service';
import { Router } from '@angular/router';
import { VendorProductLookupModalComponent } from './vendor-product-lookup-modal/vendor-product-lookup-modal.component';
import { AccountService } from '../../services/account.service';
import { Permission } from '../../models/permission.model';
import { Angular5Csv } from '../../../../node_modules/angular5-csv/dist/Angular5-csv';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
    selector: 'vendors',
    template: require('./vendors.component.html'),
    styles: [require('./vendors.component.css')],
    animations: [fadeInOut]
})
export class VendorsComponent {
    vendors: Vendor[];
    writeVendorsPermission = Permission.writeVendorsPermission;

    constructor(private router: Router, private apiService: ApiService, public dialog: MatDialog, private alertService: AlertService, public accountService: AccountService) {
        this.getVendors();
    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }


    getVendors() {
        this.apiService.getVendors().subscribe(r => {
            this.vendors = r;
        });
    }


    createEditVendorProductLookup(vendor: any) {
        let dialogRef = this.dialog.open(VendorProductLookupModalComponent, {
            width: '600px',
            data: {
                vendorId: vendor.vendorId,
                vendor: vendor
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getVendors();
        })
    }

    createEditVendor(vendor: any) {
        let dialogRef = this.dialog.open(CreateEditVendorModalComponent, {
            width: '600px',
            data: {
                currentVendor: vendor,
                vendors: this.vendors
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            this.getVendors();
        })
    }

    deleteVendor(vendorId: number) {
        this.alertService.showDialog("Do you want to delete this Vendor ?", DialogType.confirm, val => {

            this.apiService.deleteVendor(vendorId).subscribe(r => {
                this.getVendors();
            });
        });
    }

    onActivate(event) {
        if (event.type === 'click') {
            this.router.navigate(['/vendors/' + event.row.vendorId]);
        }
    }

    downloadCsv() {
        var csv = new Angular5Csv(_.map(this.vendors, g => {
            return {
                'vendorId': g.vendorId, 'vendorName': g.vendorName, 'imageURL': g.imageURL,
                'headingText': g.headingText, 'descriptionText': g.descriptionText, 'buttonText': g.buttonText
            };
        }),
            'LA_Vendor_csv_' + moment().format('YYYY-MM-DD'),
            {
                'showLabels': true, headers: ["Vendor Id", "Vendor Name", "Image Url", "Heading Text", "Description Text", "Button Text"],
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/vendors/vendors.component.ts